import { useMemo } from 'react'
import { PageLayout } from 'shared/layout'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { ConversationMenu } from 'pages/conversations/ui/ConversationMenu'
import {
  ProviderConversationsPageLayout,
  useConversationsPageLayoutContext,
} from 'pages/conversations/context/conversationsPageLayoutContext'
import { ConversationsPageLayoutStore } from 'pages/conversations/store/conversationsPageLayoutStore'

const ConversationsLayoutContent = () => {
  const store = useConversationsPageLayoutContext()
  const { pageLayoutStore, conversationMenuStore } = store

  return (
    <PageLayout
      store={pageLayoutStore}
      leftContent={
        <>
          <ConversationMenu store={conversationMenuStore} />
        </>
      }
      mobileWithSizeM
    />
  )
}

export const ConversationsPageLayout = () => {
  const entities = useEntitiesContext()
  const store = useMemo(() => new ConversationsPageLayoutStore(entities), [])

  return (
    <ProviderConversationsPageLayout value={store}>
      <ConversationsLayoutContent />
    </ProviderConversationsPageLayout>
  )
}
